export const SET_CURRENT_ORG = "SET_CURRENT_ORG"



// WEBPACK FOOTER //
// ./src/types/actions/organization.js